document.addEventListener("turbolinks:load", () => {
  $("#app_reminder_template_receiver_roles").select2();
  $("#app_reminder_template_cta_configuration_attributes_app_screen_id").select2();
});
